/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Photos_And_MediaInputs */

const en_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos & Media`)
};

const es_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos y Medios`)
};

const fr_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos & Médias`)
};

const de_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos & Medien`)
};

const ja_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写真とメディア`)
};

const zh_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照片与媒体`)
};

const ar_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصور والوسائط`)
};

const id_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto & Media`)
};

const it_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto & Media`)
};

const ru_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фото и Медиа`)
};

const pt_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos e Mídia`)
};

const ko_photos_and_media = /** @type {(inputs: Photos_And_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진 및 미디어`)
};

/**
* | output |
* | --- |
* | "Photos & Media" |
*
* @param {Photos_And_MediaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const photos_and_media = /** @type {((inputs?: Photos_And_MediaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photos_And_MediaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_photos_and_media(inputs)
	if (locale === "es") return es_photos_and_media(inputs)
	if (locale === "fr") return fr_photos_and_media(inputs)
	if (locale === "de") return de_photos_and_media(inputs)
	if (locale === "ja") return ja_photos_and_media(inputs)
	if (locale === "zh") return zh_photos_and_media(inputs)
	if (locale === "ar") return ar_photos_and_media(inputs)
	if (locale === "id") return id_photos_and_media(inputs)
	if (locale === "it") return it_photos_and_media(inputs)
	if (locale === "ru") return ru_photos_and_media(inputs)
	if (locale === "pt") return pt_photos_and_media(inputs)
	return ko_photos_and_media(inputs)
});